module.exports = __webpack_public_path__ + "assets/validated.21e63ff5.svg";